import HomeRouter from '@routers/HomeRouter/Router';

const R = {
  HomeRouter,
};

export default R;
